module.exports = function() {
  return new Worker(__webpack_public_path__ + "ae037fb138919c410e1c.worker.js");
};